import sortBy from 'lodash.sortby'

export const constants = {
  urls: {
    auth: '/authenticate',
    authSupplier: '/login/suppliers/{supplierId}/codes/{code}',
    authRefresh: '/refreshLogin',
    esProperties: {
      property: '/esProperties/{giataId}',
    },
    publicHotelierProperties: {
      property: '/publicHotelierProperties/{giataId}',
    },
    hotelierProperties: {
      factsheetInitial: '/hotelierProperties/{giataId}/factsheet/initial',
      image: '/hotelierProperties/{giataId}/images/{imageId}',
      rooms: '/hotelierProperties/{giataId}/rooms',
      room: '/hotelierProperties/{giataId}/rooms/{roomId}',
      property: '/hotelierProperties/{giataId}',
      images: '/hotelierProperties/{giataId}/images',
      imageRoomBinding: '/hotelierProperties/{giataId}/images/{imageId}/roomBindings/{roomId}',
      permissions: '/hotelierProperties/{giataId}/permissions',
      publishStatus: '/hotelierProperties/{giataId}/publishStatus',
      publishInfo: '/hotelierProperties/{giataId}/publishInfo',
      publish: '/hotelierProperties/{giataId}/publish',
      latestDescriptionForReview: '/hotelierProperties/{giataId}/descriptionsForReview/latest',
      descriptionFeedback: '/hotelierProperties/{giataId}/descriptionsForReview/{propertyDescriptionId}/feedback',
      galleries: '/hotelierProperties/{giataId}/galleries',
    },
    giataProperties: {
      images: '/giataProperties/{giataId}/images',
      property: '/giataProperties/{giataId}',
      constants: {
        blueprint: '/constants/roomBlueprint'
      },
      rooms: '/giataProperties/{giataId}/rooms',
      putHero: '/giataProperties/{giataId}/images/{imageId}/heroics',
      deleteHero: '/giataProperties/{giataId}/images/heroics',
      rejectImageInfo: '/giataProperties/{giataId}/images/{imageId}/rejectInfo',
      flowtify: '/flowtify/{giataId}',
      dashboard: {
        token: '/token/dashboard/{giataId}'
      }
    },
    giataHotelierProperties: {
      property: '/giataHotelierProperties/{giataId}'
    },
    blueprints: {
      factsheet: '/blueprints/factsheet'
    },
    dashboardBaseUrl: '',
    hash: '/hash/{hash}/type/{type}',
    countries: '/countries',
    states: '/states',
    feedback: '/feedback',
    hotelierPropertyList: '/hotelierProperties',
    confirm: '/confirm',
    order: '/giataProperties/{giataId}/images/order',
    distributionChannels: '/distribution/channels/{giataId}',
    distributionChannelFavourite: '/distribution/channels/{giataId}/favourites/{foreignChannelId}',
  },
  imageTypes: sortBy([
    {
      value: 'A',
      label: 'Exterior'
    },
    {
      value: 'BA',
      label: 'Bar'
    },
    {
      value: 'BD',
      label: 'Bathroom Example'
    },
    {
      value: 'EK',
      label: 'Shopping'
    },
    {
      value: 'F',
      label: 'Sports and leisure'
    },
    {
      value: 'FAD',
      label: 'Adventure'
    },
    {
      value: 'FO',
      label: 'Folklore'
    },
    {
      value: 'FRE',
      label: 'Relax'
    },
    {
      value: 'FRR',
      label: 'Breakfast Room'
    },
    {
      value: 'GA',
      label: 'Garden'
    },
    {
      value: 'HB',
      label: 'Indoor Pool'
    },
    {
      value: 'IT',
      label: 'Internet Café'
    },
    {
      value: 'K',
      label: 'Conference Room'
    },
    {
      value: 'KL',
      label: 'Culture'
    },
    {
      value: 'KU',
      label: 'Art'
    },
    {
      value: 'L',
      label: 'Lounge / Lobby'
    },
    {
      value: 'LG',
      label: 'Logo'
    },
    {
      value: 'LK',
      label: 'Map'
    },
    {
      value: 'LS',
      label: 'Landscape'
    },
    {
      value: 'LU',
      label: 'Aerial Photograph'
    },
    {
      value: 'MF',
      label: 'Rental Car / Vehicle'
    },
    {
      value: 'MHS',
      label: 'Sea / Harbour / Ship'
    },
    {
      value: 'MOD',
      label: 'Model Impression'
    },
    {
      value: 'P',
      label: 'Outdoor Pool'
    },
    {
      value: 'PE',
      label: 'People'
    },
    {
      value: 'PEF',
      label: 'Family'
    },
    {
      value: 'PEH',
      label: 'Wedding'
    },
    {
      value: 'PEK',
      label: 'Children'
    },
    {
      value: 'PEP',
      label: 'Couple'
    },
    {
      value: 'PER',
      label: 'Romance'
    },
    {
      value: 'PEY',
      label: 'Party'
    },
    {
      value: 'PR',
      label: 'Price'
    },
    {
      value: 'R',
      label: 'Restaurant'
    },
    {
      value: 'RV',
      label: 'Room view'
    },
    {
      value: 'RK',
      label: 'Room kitchen'
    },
    {
      value: 'S',
      label: 'Beach'
    },
    {
      value: 'SD',
      label: 'Deck Of Ship'
    },
    {
      value: 'SE',
      label: 'Point of Interest'
    },
    {
      value: 'STA',
      label: 'City'
    },
    {
      value: 'TE',
      label: 'Terrace'
    },
    {
      value: 'TI',
      label: 'Pets'
    },
    {
      value: 'W',
      label: 'Room Example'
    },
    {
      value: 'WEL',
      label: 'Health & Beauty'
    },
    {
      value: 'WBA',
      label: 'Water-based activities'
    },
    {
      value: 'X',
      label: 'Miscellaneous'
    }
  ], ['label']),
  attributePaths: {
    name: '/8f5f2bba-cf85-4810-8a70-0ac782b242b9', // [1].data.string
    name_localized: '/838e0cef-f032-40e8-9040-ee43d6f65800',
    images: '/3a74decd-e9dc-4c50-94d7-2c9db4c8ab34',
    images_sub: '/d47be08e-047c-4fde-b568-be3293e56d10',
    images_sizes: '/5ec60146-03fe-429d-90c3-50b0bff91cd5',
    images_path: '/e5fccd07-5e54-4756-b1b5-09e080d8b44f',
    rating: '/4a3bd378-91c7-4c6a-b6e1-0fab5126c0f4',
    rating_sub: '/be5b695b-fa26-4d6a-9f6c-7ec49be38118',
    city: '/ea3d0efa-6b88-4067-b38c-7f7f5e22d937',
    country: '/0407d1cd-add1-4f21-96ac-7d5a95700110',
    giataId: '/e4938b86-766b-4e03-960f-7851eb19db8b',
    media_info: '/411f0352-ca92-4f38-96b2-0fe7a81646fe',
    media_info_size: '/d2396c2a-0543-42c7-a1a1-5f60ec04fbfe',
    media_info_published: '/32cf812c-c121-4dbe-b271-da6697765f77',
    media_info_quality: '/b88cd66f-bd2f-4c06-bd55-5d82c01cec96',
    media_captions: '/2657f233-e4d5-420a-96ab-0963b8df97dd',
    image_category: '/27f61c97-7b72-44f9-b882-70635e9da5c5',
    destination: '/05bdfbdc-1ba3-42be-af44-508866a7a29a',
    country_code: '/e4938b86-766b-4e03-960f-7851eb19db8b',
    location: '/1c78d0e5-6851-49fd-8089-8a1664587c73'
  },
  languagePaths: {
    de_DE: '/e480d7fa-8827-4864-ae64-b85582a50249',
    en_EN: '/f72ffadb-80d2-4683-90c1-3df827c503de',
  },
  scores: {
    types: {
      '1': {
        name: 'TITLE_DISTRIBUTION_SCORE',
        pro: false
      },
      '2': {
        name: 'TITLE_TOUR_OPERATOR_SCORE',
        pro: false
      },
      '3': {
        name: 'TITLE_FACTS_SCORE',
        pro: false
      },
      '4': {
        name: 'TITLE_IMAGE_SCORE',
        pro: false
      },
      '5': {
        name: 'TITLE_OVERALL_SCORE',
        pro: false
      },
    },
    seq: [
      5,
      4,
      3,
      1,
      2
    ]
  }
}

export const trackingEvent = {
  editPropertyInfoField: 'Edit Property Information field',
  editMappingInfoField: 'Edit Mapping Information field',
  editRoomInfoField: 'Edit Room field',
  editImageInfoField: 'Edit Image Information field',
  clickFactsheetCategory: 'Click factsheet category',
  clickShowCodes: 'Click show codes',
  clickShowImages: 'Click show images',
  cancelRoomEdit: 'Cancel room edit',
  deleteRoom: 'Delete Room',
  addOccupancy: 'Add occupancy',
  removeOccupancy: 'Remove occupancy',
  markAsHeroImage: 'Mark as hero image',
  openEditImageBar: 'Open edit image bar',
  saveImageInfo: 'Save image info',
  assignImageToRoom: 'Assign image to room',
  addTag: 'Add tag',
  // the one below was previously called `Select motif type`
  selectMotifType: 'Select image category',
  selectPrimaryTag: 'Select primary tag',
  reorderImage: 'Reorder image',
  checkFact: 'Check fact',
  uncheckFact: 'Uncheck fact',
  editAttribute: 'Edit attribute',
  editValue: 'Edit value',
  assignToRoom: 'Assign to room',
  createRoom: 'Create Room',
  updateRoom: 'Update Room',
  confirmImages: 'Confirm Images',
  saveFactsheet: 'Save Factsheet',
  saveImages: 'Save Images',
  deleteImages: 'Delete Images',
  uploadImages: 'Upload Images',
  propertyListSearch: 'Property List Search',
  searchFacts: 'Search Facts',
  closePropertyChecklist: 'Close Property Checklist',
  openPropertyChecklist: 'Open Property Checklist',
  dismissPropertyChecklist: 'Dismiss Property Checklist',
  completePropertyChecklist: 'Complete Property Checklist',
  publishProperty: 'Publish Property',
  discardEditPropertyChanges: 'Discard Edit Property Changes',
  triggerImageConfirmationPrompt: 'Trigger Image Confirmation Prompt',
  clickBlockedPublishedButton: 'Click Blocked Published Button',
  enableDisplaySelectedFactsOnly: 'Enable Display Selected Facts Only',
  disableDisplaySelectedFactsOnly: 'Disable Display Selected Facts Only',
  gotoEditRoomsFromRoomMgmtWhatsNew: 'Go To Edit Rooms (Room Mgmt Whats New)',
  dismissRoomMgmtWhatsNew: 'Dismiss Room Mgmt Whats New',
  clickEditRoomsInImageBrowser: 'Click Edit Rooms in Property Gallery',
  reorderRoomImage: 'Reorder Room Image',
  editRoomImage: 'Edit Room Image',
  addImageToPropertyGallery: 'Add Image To Property Gallery',
  removeImageFromPropertyGallery: 'Remove Image From Property Gallery',
  deleteRoomImage: 'Delete Room Image',
  openNotificationCenter: 'Open Notification Center',
  clickNotification: 'Click Notification',
}

export const IMAGE_TYPES_MAP = new Map(constants.imageTypes.map((obj) => [obj.value, obj]))
